import { RefObject, useLayoutEffect, useRef } from 'react';

/** Позволяет прокидывать актуальное значение в memo хуки
 * @see https://epicreact.dev/the-latest-ref-pattern-in-react/
 * @see https://github.com/reactjs/rfcs/blob/useevent/text/0000-useevent.md
 */
export function useLatest<T>(value: T): RefObject<T> {
  const ref = useRef(value);

  useLayoutEffect(() => {
    ref.current = value;
  });

  return ref;
}
